import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiHolder, apis } from 'api';
const customerApi = apiHolder.api.requireLogicalApi(apis.customerApiImpl);
const mapSetting = {
    company_name: 'company_name',
    email: 'email',
    company_domain: 'company_domain',
    landline_telephone: 'telephone',
    email_suffix: 'email_suffix',
    telephone: 'telephones',
    whats_app: 'whats_app',
    home_page: 'home_page',
};
export const getBaseSelectAsync = createAsyncThunk('getBaseSelectAsync', async () => {
    return customerApi.getBaseInfo().then(res => {
        let businessStages = res.business_stage.map(item => {
            return {
                value: Number(item.stage),
                label: item.name,
                type: item.type,
            };
        });
        delete res.area;
        return Object.assign(Object.assign({}, res), { businessStages });
    });
}, {
    condition(_, api) {
        console.log('customerReducer', api.getState());
        return +new Date() - api.getState().customerReducer.baseSelectUpdateTime > 60 * 1000;
    },
});
export const getAreaSelectAsync = createAsyncThunk('getAreaSelectAsync', async () => {
    return customerApi.getGlobalArea().then(res => {
        return {
            area: res.area,
        };
    });
}, {
    condition(_, api) {
        return +new Date() - api.getState().customerReducer.areaUpdateTime > 10 * 60 * 1000;
    },
});
let customerInitialState = {
    name: 'edm-global-init',
    baseSelect: {},
    baseSelectUpdateTime: 0,
    areaUpdateTime: 0,
};
const customerSlice = createSlice({
    name: 'privilegeReducer',
    initialState: customerInitialState,
    reducers: {
        setBaseSelect: (state, action) => {
            state.baseSelect = action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(getBaseSelectAsync.fulfilled, (state, action) => {
            state.baseSelect = Object.assign(Object.assign({}, state.baseSelect), action.payload);
            state.baseSelectUpdateTime = +new Date();
        })
            .addCase(getAreaSelectAsync.fulfilled, (state, action) => {
            state.baseSelect = Object.assign(Object.assign({}, state.baseSelect), action.payload);
            state.areaUpdateTime = +new Date();
        });
    },
});
const { reducer, actions } = customerSlice;
export { actions };
export default reducer;
